<template lang="pug">

.large
  .large-intro.u-section-full.u-section-padding
    .grid.is-desktop-6.is-middle.is-center
      .column.u-mb-sm.is-widescreen-4.is-desktop-6
        h1.u-mb-xs {{$t('pageTitle')}}
        p.u-text-lg.u-mb-xs {{$t('mantra')}}
        h5 {{$t('enAr')}}
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/1.png', srcset='https://cdn.baianat.com/static/resources/large/1.png 1x, https://cdn.baianat.com/static/resources/large/1@2x.png 2x')

  .large-desc.u-section-full.u-section-padding
    p {{$t('mantraDesc1')}}
    p {{$t('mantraDesc2')}}



  section.u-mt-lg.large-sections
    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/2.png', srcset='https://cdn.baianat.com/static/resources/large/2.png 1x, https://cdn.baianat.com/static/resources/large/2@2x.png 2x')
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('webDesign')}}
        p.u-mb-xs {{$t('webDesignDesc1')}}
        p.u-mb-xs {{$t('webDesignDesc2')}}
        p {{$t('webDesignDesc3')}}

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('mobileApps')}}
        p.u-mb-xs {{$t('mobileAppsDesc1')}}
        p {{$t('mobileAppsDesc2')}}
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/3.png', srcset='https://cdn.baianat.com/static/resources/large/3.png 1x, https://cdn.baianat.com/static/resources/large/3@2x.png 2x')

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/4.png', srcset='https://cdn.baianat.com/static/resources/large/4.png 1x, https://cdn.baianat.com/static/resources/large/4@2x.png 2x')
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('logo')}}
        p.u-mb-xs {{$t('logoDesc1')}}
        p {{$t('logoDesc2')}}

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('branding')}}
        p.u-mb-xs {{$t('brandingDesc1')}}
        p {{$t('brandingDesc2')}}
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/5.png', srcset='https://cdn.baianat.com/static/resources/large/5.png 1x, https://cdn.baianat.com/static/resources/large/5@2x.png 2x')

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/6.png', srcset='https://cdn.baianat.com/static/resources/large/6.png 1x, https://cdn.baianat.com/static/resources/large/6@2x.png 2x')
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('guidelinesPresentations')}}
        p.u-mb-xs {{$t('guidelinesPresentationsDesc1')}}
        p {{$t('guidelinesPresentationsDesc2')}}

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('crafts')}}
        p.u-mb-xs {{$t('craftsDesc1')}}
        p {{$t('craftsDesc2')}}
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/7.png', srcset='https://cdn.baianat.com/static/resources/large/7.png 1x, https://cdn.baianat.com/static/resources/large/7@2x.png 2x')

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/8.png', srcset='https://cdn.baianat.com/static/resources/large/8.png 1x, https://cdn.baianat.com/static/resources/large/8@2x.png 2x')
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('advertising')}}
        p.u-mb-xs {{$t('advertisingDesc1')}}
        p {{$t('advertisingDesc2')}}

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('motionGraphics')}}
        p.u-mb-xs {{$t('motionGraphicsDesc1')}}
        p {{$t('motionGraphicsDesc2')}}
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/9.png', srcset='https://cdn.baianat.com/static/resources/large/9.png 1x, https://cdn.baianat.com/static/resources/large/9@2x.png 2x')

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/10.png', srcset='https://cdn.baianat.com/static/resources/large/10.png 1x, https://cdn.baianat.com/static/resources/large/10@2x.png 2x')
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('characterDesign')}}
        p.u-mb-xs {{$t('characterDesignDesc1')}}
        p {{$t('characterDesignDesc2')}}

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('icons')}}
        p.u-mb-xs {{$t('iconsDesc1')}}
        p {{$t('iconsDesc2')}}
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/11.png', srcset='https://cdn.baianat.com/static/resources/large/11.png 1x, https://cdn.baianat.com/static/resources/large/11@2x.png 2x')

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/12.png', srcset='https://cdn.baianat.com/static/resources/large/12.png 1x, https://cdn.baianat.com/static/resources/large/12@2x.png 2x')
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('smartWatch')}}
        p.u-mb-xs {{$t('smartWatchDesc1')}}
        p {{$t('smartWatchDesc2')}}

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('architecture')}}
        p.u-mb-xs {{$t('architectureDesc1')}}
        p {{$t('architectureDesc2')}}
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/13.png', srcset='https://cdn.baianat.com/static/resources/large/13.png 1x, https://cdn.baianat.com/static/resources/large/13@2x.png 2x')

    .grid.is-middle.is-center.u-mb-md
      .column.u-mb-sm.is-desktop-6
        img(src='https://cdn.baianat.com/static/resources/large/14.png', srcset='https://cdn.baianat.com/static/resources/large/14.png 1x, https://cdn.baianat.com/static/resources/large/14@2x.png 2x')
      .column.u-mb-sm.is-desktop-6.is-widescreen-4
        h4.u-mb-xm {{$t('casestudy')}}
        p.u-mb-xs {{$t('casestudyDesc1')}}
        p {{$t('casestudyDesc2')}}

  section.u-section-full
    img.u-img(src='https://cdn.baianat.com/static/resources/large/21.png', srcset='https://cdn.baianat.com/static/resources/large/21.png 1x, https://cdn.baianat.com/static/resources/large/21@2x.png 2x')

  section
    .grid.is-middle.is-center.u-mt-md
      .column.is-desktop-6.is-widescreen-4
        h4.u-mb-xs {{$t('arabicMock')}}
        p.u-mb-xm {{$t('arabicMockDesc')}}
      .column.is-desktop-6
        img.u-img(src='https://cdn.baianat.com/static/resources/large/15.png', srcset='https://cdn.baianat.com/static/resources/large/15.png 1x, https://cdn.baianat.com/static/resources/large/15@2x.png 2x')

  section.large-benefits.u-section-full.u-section-padding
    h3.u-mb-xm {{$t('whoBenefits')}}
    .grid.is-desktop-4
      .column.u-mb-sm
        h5 {{$t('freelancers')}}
        p {{$t('freelancersDesc')}}
      .column.u-mb-sm
        h5 {{$t('corporations')}}
        p {{$t('corporationsDesc')}}
      .column.u-mb-sm
        h5 {{$t('details')}}
        p(v-for="item in $t('detailsItems')") {{item}}





  section.large-features.u-section-full.u-section-padding
    .grid.is-desktop-4
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/large/18.png', srcset='https://cdn.baianat.com/static/resources/large/18.png 1x, https://cdn.baianat.com/static/resources/large/18@2x.png 2x')
        h5.u-mh-xs {{$t('customizability')}}
        p {{$t('customizabilityDesc')}}
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/large/19.png', srcset='https://cdn.baianat.com/static/resources/large/19.png 1x, https://cdn.baianat.com/static/resources/large/19@2x.png 2x')
        h5.u-mh-xs {{$t('easyUse')}}
        p {{$t('easyUseDesc')}}
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/large/20.png', srcset='https://cdn.baianat.com/static/resources/large/20.png 1x, https://cdn.baianat.com/static/resources/large/20@2x.png 2x')
        h5.u-mh-xs {{$t('smartObjects')}}
        p {{$t('smartObjectsDesc')}}


  section.large-cta.u-section-full.u-section-padding.u-textCenter
    .grid.is-ultrawide-5.is-widescreen-6.is-desktop-8.is-tablet-10.is-center
      .column
        p.u-text-lg.u-mb-xm {{$t('cta')}}
    AppLink(to="https://baianat.com/files/file3n1sbi1jr67yz9s" class="button is-rounded is-wide is-white" :title="$t('download')") {{$t('download')}}


</template>

<style lang="stylus">
$clMain = #151414
$clBg = #191818

div.app.is-large
  overflow: hidden
  color: #5e5a5a
  background: $clBg

  .header.is-scroll
    background: $clMain
    color: $clWhite !important

  .footer
    border-top: none

.large
  position: relative
  z-index: 1

  h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6
    color: #ada8a8

  &-intro
    background: $clMain
    color: $clWhite
    padding-top: unitRes(240, 300)
    padding-bottom: unitRes(180, 200)
    z-index: 1
    position: relative
    text-shadow: 1px 1px 11px alpha($clBlack, 0.2)
    overflow: hidden

    h1
      color: #ff595b

    h5
      color: #38c695

  &-sections
    +mq($until: 'desktop')
      text-align: center

  &-desc
    background: #111010
    padding-top: unitRes(80, 160)
    padding-bottom: unitRes(60, 120)

    p
      max-width: 900px
      margin: 0 auto 40px

  &-benefits
    background: #ff595b
    color: $clWhite
    padding-top: unitRes(80, 160)

    h5, h3
      color: $clWhite

  &-features
    background: #232121
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(50, 150)

  &-cta
    background: $clMain
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(100, 200)
</style>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,

  meta: {
    theme: 'is-large   is-whiteHeader is-fixedHeader ',
    logoText: '__NONE__'
  },
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Large Mockups",
    "pageDesc":"Large is mockups that can be used for many projects including web design, illustrations, motion graphics, apps, and branding.",
    "mantra":"140+ Large mockups, unique layouts to present your works with multiple sizes.",
    "enAr":"English & Arabic versions",
    "mantraDesc1":"Large a multipurpose mockup can be used for the presentation of your web design, web design wireframe, illustrations, icons, UI projects, motion graphics, smart watches, mobile apps, branding, logo, guidelines, advertising, graphic design, characters, crafts, case studies and architecture projects on platforms like Behance and on your different work portfolios .",
    "mantraDesc2":"It is easy-to-use and customizable for your needs; you can change sizes and colors of smart objects sizes. Either you are freelancer or working for a corporation, you can use large mockup for your presentations.",
    "webDesign":"Web design",
    "webDesignDesc1":"Present your web projects in an elegant and organized look and enjoy different possibilities of presentations in 3 ways which you can use either you have a corporation or just for freelancing.",
    "webDesignDesc2":"Through this mockup you can present your web project design, web design Wireframe, e-stores, UI kits.. and more, and you can also customize it to what suit your works.",
    "webDesignDesc3":"Just click “page” and insert smart objects into the design.",
    "mobileApps":"Mobile apps",
    "mobileAppsDesc1":"Even if you want to present designs for Android or iOS mobile phone applications, you can do this using large mockups with the particular specifications suitable for each device.",
    "mobileAppsDesc2":"Customizing these mockups has never been easier; click “page”, change sizes and colors and insert smart objects into the design.",
    "logo":"Logo",
    "logoDesc1":"Present your logos in many different ways. Customize sizes, dimensions and colors as appropriate for your projects.",
    "logoDesc2":"Just click “page” and insert smart objects into the design.",
    "branding":"Branding",
    "brandingDesc1":"Present your brand identity elements in many different ways. Customize sizes, dimensions and colors as appropriate for your projects. You can also present the stationary elements of your brand through Large.",
    "brandingDesc2":"Just click “page” and insert smart objects into the design.",
    "guidelinesPresentations":"Guidelines presentations",
    "guidelinesPresentationsDesc1":"Present the guidelines of any projects like branding, logo, applications in an attractive and descriptive way through Large mockups.",
    "guidelinesPresentationsDesc2":"Just click “page” and insert smart objects into the design.",
    "crafts":"Crafts",
    "craftsDesc1":"Crafts projects are trendy nowadays and it gives your project more charm, Large mockup allows you to present this kind of projects in attractive way that grabs more audience.",
    "craftsDesc2":"Just click “page” and insert smart objects into the design.",
    "advertising":"Advertising",
    "advertisingDesc1":"Successful advertising campaigns worth to be widely spread among many audience, make its presentation attractive and interactive by using Large mockup.",
    "advertisingDesc2":"Just click “page” and insert smart objects into the design.",
    "motionGraphics":"Motion graphics",
    "motionGraphicsDesc1":"Large mockup also gives you the chance to present your works of motion graphics and its whole process in just a few steps.",
    "motionGraphicsDesc2":"Just click “page” and insert smart objects into the design.",
    "characterDesign":"Character design",
    "characterDesignDesc1":"Present your characters with its model sheets, different poses and expressions with Large mockup and share it with all your target audience on different platforms.",
    "characterDesignDesc2":"Just click “page” and insert smart objects into the design.",
    "icons":"Icons",
    "iconsDesc1":"Present your icon set and show its features, trends, and the process of its creation to all your audience through Large mockup and get higher conversion rates.",
    "iconsDesc2":"Just click “page” and insert smart objects into the design.",
    "smartWatch":"Smart watch",
    "smartWatchDesc1":"Smartwatches and smart devices apps are the new technology that will make great changes in the next future, use Large mockup to present your apps concepts for this devices in a creative way.",
    "smartWatchDesc2":"Just click “page” and insert smart objects into the design.",
    "architecture":"Architecture",
    "architectureDesc1":"Through Large mockup you can present your architecture projects with all its details and process and also projects related like interior, exterior and landscape designs.",
    "architectureDesc2":"Just click “page” and insert smart objects into the design.",
    "casestudy":"Casestudy",
    "casestudyDesc1":"Case studies also need presentations, specially the ones that based on media and imagery, use Large mockup to make the presentations of your case studies and higher its engagement rates.",
    "casestudyDesc2":"Just click “page” and insert smart objects into the design.",
    "arabicMock":"72 arabic mock ups",
    "arabicMockDesc":"The Arabic version of Large mockups, contains 72 different mockup with light and dark styles in different sizes, this version is suitable for Middle East countries and also Right-direction languages.",
    "whoBenefits":"Who benefits",
    "freelancers":"Freelancers",
    "freelancersDesc":"Use large mockup to present your design projects and use it on your Behance account.",
    "corporations":"Corporations",
    "corporationsDesc":"If you have a corporation, use large mockup to present your works on Behance.",
    "details":"Details",
    "detailsItems":{
      "1":"Type: Dark and Light with multiple sizes",
      "2":"Format: PSD",
      "3":"Count: 144",
      "4":"Size: 1 GB",
      "5":"Licence: Commercial"
    },
    "customizability":"Customizability",
    "customizabilityDesc":"Customize large mockups as appropriate for your projects; change colors, sizes and more.",
    "easyUse":"Easy to use",
    "easyUseDesc":"Large mockups are not complicated. You can use them easily to present any projects.",
    "smartObjects":"Smart Objects",
    "smartObjectsDesc":"Large mockup consists of smart objects, so you can easily change them in your design.",
    "cta":"140+ Large mockups, unique layouts to present your works with multiple sizes.",
    "download":"Download"
  },
  "ar": {
    "pageTitle":"قوالب لارج",
    "pageDesc":"لارج عبارة عن موك أب يمكن استخدامه لعرض تصميمات الويب والرسوم التوضيحية والأيقونات والرسومات المتحركة والشعارات.",
    "mantra":"140 + قالب بتصميمات فريدة لعرض أعمالك بشكل جذاب. يأتي بأحجام مختلفة",
    "enAr":"يتوفر باللغة العربية والإنجليزية.",
    "mantraDesc1":"يمكن استخدام لارج لعرض تصميمات الموقع الخاصة بك والتأطير الشبكي والأيقونات و مشاريع واجهة المستخدم والرسوم التوضيحية و الرسوم المتحركة و الساعات الذكية و تطبيقات الجوال والعلامة التجارية والشعار والإرشادات والإعلانات و الجرافيك ديزاين و الشخصيات ودراسات الحالة ومشاريع الهندسة المعمارية على منصات مثل بيهانس أو الملف الشخصي الخاص بك.",
    "mantraDesc2":"إنها سهلة الاستخدام وقابلة للتخصيص لاحتياجاتك. يمكنك تغيير أحجامها وألوانها. سواء كنت مستقلاً أو تعمل لحساب شركة، يمكنك استخدام لارج لعرضك التقديمي.",
    "webDesign":"تصميم المواقع",
    "webDesignDesc1":"اعرض مشروع الموقع الخاص بك بطريقة جذابة وفريدة. من خلال لارج يمكنك تقديم مشروع تصميم موقعك، والتأطير الشبكي لتصميم موقعك، والمتاجر الإلكترونية، ومجموعات واجهة المستخدم ...وأكثر من ذلك.",
    "webDesignDesc2":"ويمكنك تخصيصه بما يتناسب مع عملك.",
    "webDesignDesc3":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "mobileApps":"تطبيقات الجوال",
    "mobileAppsDesc1":"إذا كنت ترغب في تقديم تصميمات لتطبيقات الهاتف الجوال بنظام الأندرويد أو iOs فيمكنك القيام بذلك باستخدام قوالب لارج ذات المواصفات الخاصة المناسبة لكل جهاز.",
    "mobileAppsDesc2":"لم يكن تخصيص القوالب سهلًا من قبل؛ انقر فوق 'صفحة'، لتغيير الأحجام والألوان وإدراج smart objects في التصميم.",
    "logo":"الشعار",
    "logoDesc1":"اعرض شعاراتك بطرق متعددة ومختلفة. خصص الألوان والأحجام والأبعاد لمشاريعك.",
    "logoDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "branding":"العلامة التجارية",
    "brandingDesc1":"اعرض عناصر هويتك التجارية بعدة طرق مختلفة. خصص الأحجام والأبعاد والألوان المناسبة لمشاريعك. يمكنك أيضًا تقديم العناصر الثابتة لعلامتك التجارية من خلال لارج.",
    "brandingDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "guidelinesPresentations":"إرشادات العروض التقديمية",
    "guidelinesPresentationsDesc1":"عرض الإرشادات الخاصة بأي مشروع مثل العلامة التجارية والشعار وتطبيقات الجوال بطريقة جذابة من خلال القوالب.",
    "guidelinesPresentationsDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "crafts":"الأعمال اليدوية",
    "craftsDesc1":"المشاريع التي تم صنعها بطريقة يدوية تعتبر عصرية في الوقت الحاضر، وتمنح مشروعك سحرًا أكبر. تساعدك قوالب لارج بتقديم هذا النوع من المشاريع لجذب المزيد من الجمهور تجاه أعمالك.",
    "craftsDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "advertising":"الإعلانات",
    "advertisingDesc1":"افتخر بالحملات الإعلانية الناجحة التى صممتها، واجعلها عالقة في الذاكرة واعرضها بشكل يعبر عنك باستخدام قوالب لارج.",
    "advertisingDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "motionGraphics":"الموشن جرافيك.",
    "motionGraphicsDesc1":"من السيناريو إلى الاسكتش وتصميم الصوت، يمكنك توضيح العملية بأكملها من خلال القوالب التي تدعم الأنيميشن.",
    "motionGraphicsDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "characterDesign":"تصميم الشخصيات",
    "characterDesignDesc1":"اعرض نماذج شخصياتك التي صممتها على الورق، وتعبيراتها المختلفة بطريقة تجعلها نابضة بالحياة وأكثر واقعية.",
    "characterDesignDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "icons":"الأيقونات",
    "iconsDesc1":"خصص عرضك التقديمي ليتماشي مع الأيقونات، والاتجاهات، وسلط الضوء على أهم مفاهيم التصميم الخاصة بك.",
    "iconsDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "smartWatch":"الساعة الذكية",
    "smartWatchDesc1":"استخدم القوالب لتقديم المفاهيم المبتكرة لأجهزة الساعة الذكية الصغيرة خلال بضع نقرات.",
    "smartWatchDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "architecture":"الهندسة المعمارية",
    "architectureDesc1":"اعرض مشاريع التصميم والهندسة الداخلية والخارجية و تصميم المشاهد الطبيعية بكافة تفاصيلها وعملياتها.",
    "architectureDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "casestudy":"دراسة الحالة",
    "casestudyDesc1":"نظم دراسات الحالة التي تقدمها وركز أكثر على الأقسام المخصصة للصور و الإحصاءات والنتائج المثيرة للاهتمام.",
    "casestudyDesc2":"ما عليك سوى النقر فوق 'صفحة' وإدراج smart objects في التصميم.",
    "arabicMock":"72 قالب عربي",
    "arabicMockDesc":"النسخة العربية من لارج تحتوي على 72 قالب، بالشكل الداكن أو الفاتح بأحجام مختلفة، ويعتبر هذا الإصدار مناسب لكل من بلدان الشرق الأوسط وكذلك لاتجاه اللغة.",
    "whoBenefits":"لمْن تم تصميمها",
    "freelancers":"الفريلانسر",
    "freelancersDesc":"استخدم قوالب لارج لعرض مشاريع التصميم الخاصة بك واستخدامها على حساب بيهانس.",
    "corporations":"الشركات",
    "corporationsDesc":"إذا كان لديك شركة، استخدم قوالب لارج لعرض أعمالك على بيهانس.",
    "details":"التفاصيل",
    "detailsItems":{
      "1":"النوع: داكن وفاتح بأحجام متعددة",
      "2":"التنسيق: PSD",
      "3":"الاحصاء: 144",
      "4":"الحجم: 1 جيجا بايت",
      "5":"الترخيص: تجاري"
    },
    "customizability":"مخصصة",
    "customizabilityDesc":"خصص قوالب لارج بشكل مناسب لمشاريعك حيث يمكنك تغيير الألوان والأحجام وأكثر من ذلك.",
    "easyUse":"سهل الاستخدام",
    "easyUseDesc":"ليس معقدًا كما تظن. يمكنك استخدامه بسهولة لتقديم مشاريعك.",
    "smartObjects":"Smart Objects",
    "smartObjectsDesc":"يتكون لارج من Smart Objects، بحيث يمكنك بسهولة تغييرها في التصميم الخاص بك.",
    "cta":"140 قالب لعرض تصميماتك الفريدة بأحجام متعددة.",
    "download":"تحميل"
  }
}
</i18n>
